<form
  autocomplete="on"
  class="or-d-flex or-flex-col or-align-items-center or-justify-content-between or-h-100-pc"
  [formGroup]="credentialsForm"
  (ngSubmit)="onButtonClicked()">
  <div class="or-d-flex or-flex-col or-mx-16-px or-align-self-stretch margin-top--20-px">
    <or-input-with-icon placeholder="E-mail" type="email" autocomplete="username" formControlName="email" />

    <or-input-with-icon
      class="or-mt-8-px"
      placeholder="Hasło"
      [type]="showPassword() ? 'text' : 'password'"
      autocomplete="current-password"
      [icon]="showPassword() ? 'assets/icons/v2/eye-off.svg' : 'assets/icons/v2/eye.svg'"
      (iconClick)="toggleShowPassword()"
      formControlName="password" />

    @if (isRegister()) {
      <or-input-with-icon
        class="or-mt-8-px"
        placeholder="Powtórz hasło"
        [type]="showPassword2() ? 'text' : 'password'"
        [icon]="showPassword2() ? 'assets/icons/v2/eye-off.svg' : 'assets/icons/v2/eye.svg'"
        (iconClick)="toggleShowPassword2()"
        formControlName="password2" />
    }
    @if (!isRegister()) {
      <span
        (click)="resetPasswordModal()"
        class="reset-password-link or-head-xs or-color-gradient or-mt-12-px or-cursor-pointer or-text-decoration-underline">
        Przypomnij hasło
      </span>
    }
  </div>

  <div class="cta-container or-w-100-pc or-pt-16-px or-pb-24-px or-px-16-px">
    <button
      type="submit"
      class="button-primary-style or-h-48-px or-w-100-pc or-head-xs or-color-white"
      [class.disabled-button]="!credentialsForm.valid"
      [disabled]="!credentialsForm.valid">
      {{ isRegister() ? 'Zarejestruj się i dołącz do gier!' : 'Zaloguj się i dołącz do gier!' }}
    </button>
    <div class="or-text-sm or-text-align-center or-mt-16-px">
      {{ isRegister() ? 'Rejestrując się' : 'Logując się' }} akceptujesz
      <span (click)="getTermsOfService()" class="or-text-decoration-underline or-color-primary or-cursor-pointer"
        >Regulamin</span
      >
      i
      <span (click)="getPolicyPrivacy()" class="or-text-decoration-underline or-color-primary or-cursor-pointer"
        >Politykę prywatności</span
      >
    </div>
  </div>
</form>
